import {createApiClient} from "./client";

export const useTenantApi = () => {
	const api = createApiClient();
	return {
		getTenant: (tenantId: string) =>
			api.get('/api/booking/v2/tenants/{tenantId}', {
				path: { tenantId }
			})
	}
}
